




























import Vue, { VueConstructor } from "vue";
import VaButton from "@/components/atoms/VaButton.vue";
import WizardService from "@/services/wizardService";
import wizardStepsMixin, {
  WizardMixin,
} from "@/components/mixins/wizardStepsMixin";
import VaCard from "@/components/molecules/VaCard.vue";

export default (Vue as VueConstructor<WizardMixin>).extend({
  name: "WizardConnect",
  mixins: [wizardStepsMixin],
  data() {
    return {
      code: (this.$route.query?.devicePin
        ? this.$route.query.devicePin
        : this.$route.params.id || "") as string,
      isLoading: false,
      autoconnect: this.$route.query?.wrongConfigurationType == "true",
    };
  },
  props: {
    type: {
      type: String, //ChangeLicense | Complete | LicenseRegistration
      required: false,
      default: "Complete",
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: { VaCard, VaButton },
  computed: {},
  mounted() {
    if (this.code != "" && this.autoconnect) {
      this.connectToRoom();
    }
  },
  methods: {
    onInput() {
      this.code = this.code.toUpperCase();
    },
    async connectToRoom() {
      try {
        this.isLoading = true;
        const configuration = await WizardService.connectToRoom(
          this.code,
          this.type
        );
        this.$emit("onFetchConfiguration", configuration);
      } catch (e) {
        this.handleError(e);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
